module.exports = __webpack_public_path__ + "img/top-4-3.944d1fb3.jpg";